module.exports = __webpack_public_path__ + "img/caidan.5fc74737.png";